import { render, staticRenderFns } from "./Zx.vue?vue&type=template&id=47843653&scoped=true"
import script from "./Zx.vue?vue&type=script&lang=js"
export * from "./Zx.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47843653",
  null
  
)

export default component.exports